import React, { Fragment, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import {
  AxisDate,
  AxisDateTimeFull,
  AxisHoursWork,
  AxisTime,
} from "../util/AxisDateTime";
import { Link } from "react-router-dom";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";
import AxisSpinner from "../components/AxisSpinner";

const ApproveTimesheet = ({ shift, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          timesheet_id: shift?.timesheet?.id,
        },
      };
      const response = await authAxios().post(
        "/api/backoffice/timesheet/confirm",
        null,
        config,
      );

      const fetchConfig = {
        headers: {
          "content-type": "application/json",
        },
        params: {
          shift_id: shift?.id,
        },
      };

      const shiftResponse = await authAxios().get(
        "/api/backoffice/shifts/" +
          (shift?.table === "shifts" ? "active" : "archive"),
        fetchConfig,
      );

      setLoading(false);
      onComplete(shiftResponse.data);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  return (
    <Fragment>
      <div>
        <Table striped hover responsive>
          <thead>
            <tr>
              <th colSpan={2}>
                <h5 className={"text-axis-offblack"}>Timesheet Information</h5>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Status</td>
              <td className={"font-weight-bold"}>
                {shift?.timesheet === null
                  ? "Missing"
                  : shift?.timesheet?.status}
              </td>
            </tr>
            <tr>
              <td>Timesheet ID:</td>
              <td>{shift?.timesheet?.id}</td>
            </tr>
            <tr>
              <td>Timesheet Week:</td>
              <td>{AxisDate(shift?.timesheetWeek)}</td>
            </tr>

            {shift?.timesheet?.status === "APPROVED" ? (
              <tr>
                <td>Approved By:</td>
                <td>
                  {AxisDateTimeFull(shift?.timesheet?.approvedOn)}
                  {" by "}
                  <Link
                    to={{
                      pathname: `/users/${shift?.timesheet?.approvedBy?.id}`,
                    }}
                  >
                    {shift?.timesheet?.approvedBy?.surname},{" "}
                    {shift?.timesheet?.approvedBy?.forename}{" "}
                  </Link>
                </td>
              </tr>
            ) : null}

            <tr>
              <td>User</td>
              <td className={"font-weight-bold"}>
                <Link
                  to={{
                    pathname: `/users/${shift?.user?.id}`,
                  }}
                >
                  {shift?.user?.surname}, {shift?.user?.forename}
                </Link>
              </td>
            </tr>
            <tr>
              <td>Start</td>
              <td className={"font-weight-bold"}>
                {shift?.timesheet === null
                  ? "N/A"
                  : AxisTime(shift?.timesheet?.start)}
              </td>
            </tr>
            <tr>
              <td>End</td>
              <td className={"font-weight-bold"}>
                {shift?.timesheet === null
                  ? "N/A"
                  : AxisTime(shift?.timesheet?.end)}
              </td>
            </tr>
            <tr>
              <td>Hours Worked</td>
              <td className={"font-weight-bold"}>
                {AxisHoursWork(shift?.timesheet?.hoursWorked)}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      {loading ? <AxisSpinner loading={loading} /> : null}
        
      <ButtonModalFormSaveClose
        saveName={"Approve"}
        formSave={onSave}
        loading={loading}
        close={close}
      />
    </Fragment>
  );
};

export default ApproveTimesheet;
